import React from 'react';
import './FmScrubberSlot.css';

export interface FmScrubberSlotProps {
  /** Content injected by consuming pages (planner, map-view). Empty by default. */
  children?: React.ReactNode;
}

/**
 * FmScrubberSlot — bottom chrome shell slot for the timeline scrubber.
 *
 * Glass-styled bottom bar present in the shell on all routes.
 * Empty/zero-height by default; the planner/map pages set the CSS custom
 * property `--fm-scrubber-slot-h` via FmShellSlotsContext to reveal and
 * populate the slot.
 * Accepts `children` so consuming pages can inject content without DOM hacks.
 *
 * data-testid="fm-scrubber-slot" — always attached to the DOM.
 */
export const FmScrubberSlot: React.FC<FmScrubberSlotProps> = ({ children }) => {
  const hasContent = Boolean(children);

  return (
    <section
      className={hasContent ? 'fm-scrubber-slot fm-scrubber-slot--active' : 'fm-scrubber-slot'}
      data-testid="fm-scrubber-slot"
      aria-label="Timeline scrubber"
      aria-hidden={!hasContent ? true : undefined}
    >
      <div className="fm-scrubber-slot__content">{children}</div>
    </section>
  );
};

export default FmScrubberSlot;
